export const isValidSolutionFilename = (filename) => filename.endsWith('.json');

export const parseSolutionJson = (json) => {
  const parsed = JSON.parse(json);
  const isUnassignedOnly = parsed?.tours?.length === 0 && !!(parsed.notices || parsed.unassigned);
  return { parsed, isUnassignedOnly };
};

export const buildPostMessageFiles = ({
  problem,
  solution,
  problemFilename,
  solutionFilename,
}) => {
  const files = [];
  if (problem) {
    files.push({
      fileContent: problem,
      filename: problemFilename || 'problem.json',
    });
  }
  if (solution) {
    files.push({
      fileContent: solution,
      filename: solutionFilename || 'solution.json',
    });
  }
  return files;
};

